"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'CellStyleModal',
  // 自定义单元格样式属性
  data() {
    return {
      predefineColors: ['#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#fff2cc', '#e3d9cf'],
      visible: false,
      index: undefined,
      record: {
        style: {
          backgroundColor: 'transparent',
          fontWeight: 'normal'
        }
      }
    };
  },
  methods: {
    open(data) {
      const {
        record,
        index
      } = _.cloneDeep(data);
      const defaultStyle = {
        backgroundColor: 'transparent',
        fontWeight: 'normal'
      };
      this.record = _.merge({
        style: defaultStyle
      }, record);
      this.index = index;
      this.visible = true;
    },
    handleOk() {
      this.$emit('ok', this.record, this.index);
      this.visible = false;
    }
  }
};